import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { SupportLandingPageIcon } from './support-landing-page';
import { supportRootRouteRef } from '../../routes';

export const supportLandingPage = PageBlueprint.make({
  params: {
    title: 'Support',
    path: '/support',
    icon: SupportLandingPageIcon,
    routeRef: supportRootRouteRef,
    loader: () =>
      import('./support-landing-page').then(m => <m.SupportLandingPage />),
  },
});

export const supportLandingPagePlugin = createFrontendPlugin({
  pluginId: 'support-landing-page',
  extensions: [supportLandingPage],
});
